/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import InsuranceTreatmentFee from './InsuranceTreatmentFee/index'
import React from 'react'
import TotalInsuranceClaim from './TotalInsuranceClaim/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Summary/InsuranceSummary/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-3-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
</div>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 marginTop={dtSpaceS}
 marginLeft={dtSpaceXs}
 marginRight={dtSpaceXs}
 text="Insurance claim summary"
/>
<InsuranceTreatmentFee
  viewPath={`${viewPath}/InsuranceTreatmentFee`}
/>
<TotalInsuranceClaim
  viewPath={`${viewPath}/TotalInsuranceClaim`}
/>
{children}
</React.Fragment>)
}